import priorityNav from 'priority-nav';

export default () => {
  if ($('.events-sub-nav').length) {
    const $component = $('.events-sub-nav');

    priorityNav.init({
      initClass: 'js-events-sub-nav-links',
      mainNavWrapper: '.events-sub-nav-links',
      navDropdownClassName: 'priority-nav-dropdown',
      navDropdownToggleClassName: 'priority-nav-dropdown-toggle',
      navDropdownLabel: 'More Info',
      breakPoint: 100,
      throttleDelay: '50'
    });

    $component.addClass('-initialized');
  }
};
